<template>
  <div class="export-buttons" v-click-outside="closeExportButton">
    <ButtonComponent
      @click="toggleExport"
      :disabled="getIsBlocked"
      buttonType="button"
      class="export-buttons__button"
      :mod="modButton"
    >
      <IconComponent v-if="!loading" :name="iconName" />
      <slot name="buttonHead">{{ getCurrentNameButton }}</slot>
    </ButtonComponent>
    <div class="export-buttons__button_hidden">
      <ButtonComponent disabled>
        {{ getMaxButtonText }}
      </ButtonComponent>
    </div>
    <div
      class="export-buttons__export-type-btn-list"
      :class="{ 'export-buttons__export-type-btn-list--visible': isVisibleExportButtons }"
    >
      <ButtonComponent
        v-for="button in getExportButtons"
        :key="button.type"
        v-permission="permissionCodes[button.type]"
        class="export-buttons__export-btn"
        :disabled="getIsBlocked"
        @click="exportType(button.type)"
      >
        {{ button.name }}
      </ButtonComponent>
    </div>
  </div>
</template>

<script>
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import IconComponent from '@/common/ui/IconComponent.vue';
  import { setGlobalWaitCursor } from '@/common/utils/cursor';

  const namesExportButtons = {
    word: 'Word (.docx)',
    excel: 'Excel (.xlsx)',
    pdf: 'PDF (.pdf)',
    pptx: 'PowerPoint (.pptx)',
  };

  export default {
    name: 'ExportButtons',
    emits: ['exportWord', 'exportExcel', 'exportPdf', 'toggleExport', 'exportPptx'],
    components: {
      ButtonComponent,
      IconComponent,
    },
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      nameButton: {
        type: String,
        default: 'Скачать',
      },
      modButton: {
        type: String,
      },
      exportTypes: {
        type: Array,
        default: () => ['word', 'excel', 'pdf', 'pptx'],
      },
      permissionCodes: {
        type: Object,
        default: () => ({
          word: undefined,
          excel: undefined,
          pdf: undefined,
          pptx: undefined,
        }),
      },
      iconName: {
        type: String,
        default: 'downloadBlue',
      },
    },
    data() {
      return {
        isVisibleExportButtons: false,
      };
    },
    computed: {
      getCurrentNameButton() {
        return this.loading ? 'Загрузка...' : this.nameButton;
      },
      getExportButtons() {
        return this.exportTypes.map((type) => ({
          name: namesExportButtons[type],
          type,
        }));
      },
      getMaxButtonText() {
        return this.exportTypes.reduce((acc, type) => {
          const text = namesExportButtons[type];
          return acc.length > text.length ? acc : text;
        }, '');
      },
      getIsBlocked() {
        return this.disabled || this.loading;
      },
    },
    watch: {
      loading(newVal) {
        setGlobalWaitCursor(!!newVal);
      },
    },
    mounted() {
      if (this.loading) {
        setGlobalWaitCursor(true);
      }
    },
    beforeUnmount() {
      if (this.loading) {
        setGlobalWaitCursor(false);
      }
    },
    methods: {
      toggleExport() {
        this.isVisibleExportButtons = !this.isVisibleExportButtons;
        this.$emit('toggleExport', this.isVisibleExportButtons);
      },
      closeExportButton() {
        this.isVisibleExportButtons = false;
      },
      exportType(type) {
        this.closeExportButton();
        this.$emit(`export${type.charAt(0).toUpperCase() + type.slice(1)}`);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .export-buttons {
    position: relative;
    display: inline-block;
    max-height: 40px;

    @media (max-width: $mobile) {
      width: 100%;
    }

    &__button {
      width: 100%;
      display: flex;
      justify-content: center;
      gap: 4px;

      &_hidden {
        height: 0;
        overflow: hidden;
        white-space: nowrap;
      }
    }

    &__export-type-btn-list {
      position: absolute;
      top: 0;
      opacity: 0;
      min-width: 100%;
      width: max-content;
      right: 50%;
      transform: translateX(50%);
      display: flex;
      flex-direction: column;
      gap: 4px;
      z-index: 401;
      pointer-events: none;
      transition-property: opacity, top;
      transition-duration: 0.3s;
      transition-timing-function: ease;

      &--visible {
        top: 44px;
        opacity: 1;
        pointer-events: auto;
      }
    }
  }
</style>
